import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Modal, Tabs, Spin } from 'antd';
import { Icon, Picker, List, Modal as ModalMobile } from 'antd-mobile'
import IdleTimer from 'react-idle-timer';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import InputAdornment from '@material-ui/core/InputAdornment';
import Event from '@material-ui/icons/Event';
import DateFnsUtils from '@date-io/date-fns';
import { withTranslation } from 'react-i18next';
import * as SignalR from '@aspnet/signalr';
import BookingDetailModal from './bookingDetailModal';
import BookingTabPage from './bookingTab';
import { Markup } from 'interweave';

const { Content } = Layout;
const { TabPane } = Tabs;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;
const confirmAlert = ModalMobile.alert;

@inject(
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'webSettingStore',
    'bookingSummaryStore',
    'loginStore',
)
@observer
class BookingMainPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.idleTimer = null;
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });


        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
        this.props.bookingSummaryStore.getMenu();
        this.props.bookingSummaryStore.initGetBookings();

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('BOOKING_FACILITY').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentDidUpdate() {
        this.tabStyle();
        this.calendarStyle();
    }

    componentWillUnmount() {
        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
        this.props.bookingSummaryStore.setBookingSearchText('');
        this.props.bookingSummaryStore.setBookingSearchSubCategory('All');
        this.props.bookingSummaryStore.searchBookingByNameAndSubCategory();
    }

    tabStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const tabs = document.getElementsByClassName('ant-tabs-tab');

            for (let i = 0; i < tabs.length; i++) {
                tabs[i].style.fontFamily = `${activeTemplate.templateSetting.tab.fontFamily}`;
                tabs[i].style.fontSize = `${activeTemplate.templateSetting.tab.fontSize}px`;
                tabs[i].style.lineHeight = `${activeTemplate.templateSetting.tab.fontSize + 2}px`;
                tabs[i].style.color = activeTemplate.templateSetting.tab.color;
            }

            const tabActives = document.getElementsByClassName('ant-tabs-tab-active');

            for (let i = 0; i < tabActives.length; i++) {
                tabActives[i].style.fontFamily = `${activeTemplate.templateSetting.tabSelected.fontFamily}`;
                tabActives[i].style.fontSize = `${activeTemplate.templateSetting.tabSelected.fontSize}px`;
                tabActives[i].style.lineHeight = `${activeTemplate.templateSetting.tabSelected.fontSize + 2}px`;
                tabActives[i].style.color = activeTemplate.templateSetting.tabSelected.color;
            }

            const tabInk = document.getElementsByClassName('ant-tabs-ink-bar');

            for (let i = 0; i < tabInk.length; i++) {
                tabInk[i].style.background = `${activeTemplate.templateSetting.tabSelected.color}`;
            }
        }
    }

    calendarStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const input = document.getElementsByClassName('MuiInputBase-input');

            for (let i = 0; i < input.length; i++) {
                input[i].style.fontFamily = `${activeTemplate.templateSetting.text.fontFamily}`;
                input[i].style.fontSize = `${activeTemplate.templateSetting.text.fontSize}px`;
                input[i].style.lineHeight = `${activeTemplate.templateSetting.text.fontSize + 2}px`;
                input[i].style.color = activeTemplate.templateSetting.text.color;
            }
        }
    }

    // ON CHANGE

    bookingSearchOnChange = (e) => {
        this.props.bookingSummaryStore.setBookingSearchText(e.target.value);
        this.props.bookingSummaryStore.searchBookingByNameAndSubCategory();
    }

    bookingSelectOnChange = (subCategories) => {
        const subCategory = subCategories[0];
        this.props.bookingSummaryStore.setBookingSearchSubCategory(subCategory);
        this.props.bookingSummaryStore.searchBookingByNameAndSubCategory();
    }

    bookingDateOnChange = (obj) => {
        this.props.bookingSummaryStore.setBookingDateText(obj.date);
        this.props.bookingSummaryStore.setBookingDate(obj.date);
    }

    // ON CLICK

    back = () => {
        this.props.history.push('/');
    }

    // ON TAB CLICK

    tabClick = (key) => {
        const categoryTaskId = key.toString();
        this.props.bookingSummaryStore.setBookingTabSubCategoriesByTabCategoryTaskId(categoryTaskId);
        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
        this.props.bookingSummaryStore.setBookingSearchText('');
        this.props.bookingSummaryStore.setBookingSearchSubCategory('All');
        this.props.bookingSummaryStore.searchBookingByNameAndSubCategory();
    }

    // ON TOUCH

    _onTouchStart(e, that) {
        const touch = e.touches[0];
        that.props.bookingSummaryStore.setSwipeX(touch.clientX);
        that.props.bookingSummaryStore.setIsSwipe(false);
    }

    _onTouchMove(e, that) {
        if (e.changedTouches && e.changedTouches.length) {
            that.props.bookingSummaryStore.setIsSwipe(true);
        }
    }

    _onTouchEnd(e, that, bookingCategoryId) {
        const { swipeX, isSwipe, bookingTabCategories } = that.props.bookingSummaryStore;
        const touch = e.changedTouches[0];
        const absX = Math.abs(touch.clientX - swipeX);
        if (isSwipe && absX > 50) {
            if (touch.clientX - swipeX < 0) {
                let nextCategoryTaskId = 0;
                for (let i = 0; i < bookingTabCategories.length; i += 1) {
                    if (bookingTabCategories[i].id === bookingCategoryId) {
                        if (bookingTabCategories[i + 1]) {
                            nextCategoryTaskId = bookingTabCategories[i + 1].id;
                            that.tabClick(nextCategoryTaskId);
                        }
                        return;
                    }
                }
            } else {
                let prevCategoryTaskId = 0;
                for (let i = 0; i < bookingTabCategories.length; i += 1) {
                    if (bookingTabCategories[i].id === bookingCategoryId) {
                        if (bookingTabCategories[i - 1]) {
                            prevCategoryTaskId = bookingTabCategories[i - 1].id;
                            that.tabClick(prevCategoryTaskId);
                        }
                        return;
                    }
                }
            }
        }

        that.props.bookingSummaryStore.setSwipeX(0);
        that.props.bookingSummaryStore.setIsSwipe(false);
    }

    refreshPage = () => {
        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
        this.props.bookingSummaryStore.initGetBookings();
    }

    // Idle Timer

    handleOnIdle = () => {
        confirmAlert('Info', <div>There was no activity for a while. Please refresh the page.</div>, [
            {
                text: 'OK', onPress: () => {
                    window.location.reload(true);
                }
            }
        ]);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const history = this.props.history;
        const {
            menu,
            showBookingDetailModal,
            bookingTabCategories,
            bookingItems,
            bookingFilterItems,
            // bookingSearchText,
            bookingSearchSubCategory,
            bookingTabSubCategories,
            bookingTabCategoryIdActive,
            bookingDate,
            // bookingDateText,
            bookingLoading
        } = this.props.bookingSummaryStore;

        let maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 7);

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 60 * 3} onIdle={this.handleOnIdle} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <>
                                                <Modal
                                                    className='stm-modal'
                                                    title='Booking Detail'
                                                    onCancel={() => { this.props.bookingSummaryStore.setShowBookingDetailModal(false) }}
                                                    visible={showBookingDetailModal}
                                                >
                                                    <BookingDetailModal history={history} />
                                                </Modal>

                                                <Content>
                                                    {/* Header */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {menu ? menu.taskName : ''}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    {/* Body */}
                                                    <>
                                                        {
                                                            (bookingTabCategories.length === 0 && bookingItems.length === 0) || bookingLoading
                                                                ?
                                                                <>
                                                                    <Row>
                                                                        <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                                                            <Spin
                                                                                spinning={true}
                                                                                tip={webSettting.loadingDataText}
                                                                                style={{
                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                    color: activeTemplate.templateSetting.text.color,
                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize
                                                                                }}>
                                                                            </Spin>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                :
                                                                <Row>
                                                                    <Col span={24} className='stm-margin-top-50'>
                                                                        <Tabs
                                                                            activeKey={bookingTabCategoryIdActive}
                                                                            className='stm-tab'
                                                                            type='line'
                                                                            onTabClick={this.tabClick}
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.tab.fontFamily,
                                                                                color: activeTemplate.templateSetting.tab.color,
                                                                                fontSize: activeTemplate.templateSetting.tab.fontSize,
                                                                                lineHeight: `${activeTemplate.templateSetting.tab.fontSize + 2}px`
                                                                            }}
                                                                        >
                                                                            {
                                                                                bookingTabCategories.map((tab) => {
                                                                                    let itemFilters = bookingFilterItems.filter(fi => fi.bookingCategoryId === tab.id);

                                                                                    return (
                                                                                        <TabPane tab={tab.name} key={tab.id} className='stm-tabpane'>
                                                                                            <Row>
                                                                                                <Col span={24} className='stm-padding-top-4'>
                                                                                                    <>
                                                                                                        {
                                                                                                            tab.description === null || tab.description === ''
                                                                                                                ?
                                                                                                                null
                                                                                                                :
                                                                                                                <Row className='stm-tab-description-container'>
                                                                                                                    <Col span={24} className='stm-tab-description'>
                                                                                                                        <Row>
                                                                                                                            <Col span={3} className='stm-tab-description-image'>
                                                                                                                                <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                                                            </Col>
                                                                                                                            <Col
                                                                                                                                span={21}
                                                                                                                                className='stm-tab-description-text'
                                                                                                                                style={{
                                                                                                                                    fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                                    fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                                                                                                    lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                                                                                                    color: activeTemplate.templateSetting.buttonItem.color
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <Markup content={tab.description} />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                        }
                                                                                                    </>

                                                                                                    <>
                                                                                                        <Row className='stm-tab-filter-container'>
                                                                                                            <>
                                                                                                                {
                                                                                                                    bookingTabSubCategories.length > 1
                                                                                                                        ?
                                                                                                                        <Col span={24} className='stm-tab-filter'>
                                                                                                                            <Picker
                                                                                                                                data={[bookingTabSubCategories]}
                                                                                                                                title='Select Sub Category'
                                                                                                                                cascade={false}
                                                                                                                                value={[bookingSearchSubCategory]}
                                                                                                                                okText={webSettting.okText}
                                                                                                                                dismissText={webSettting.cancelText}
                                                                                                                                onOk={this.bookingSelectOnChange}
                                                                                                                            >
                                                                                                                                <List.Item>
                                                                                                                                    <Row className='stm-margin-bottom-2'>
                                                                                                                                        <Col span={24} className='stm-list-category'>
                                                                                                                                            <Row
                                                                                                                                                className='stm-width-100-percent'
                                                                                                                                                style={{
                                                                                                                                                    fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                                                    fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                                                    lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                                                    color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                                                                    backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                <Col span={20}>
                                                                                                                                                    <span>{bookingSearchSubCategory === 'All' ? 'All' : bookingSearchSubCategory}</span>
                                                                                                                                                </Col>
                                                                                                                                                <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                                    <img src={require('../../assets/image/Icon/Arrow-Down.svg')} alt='Arrow-Down' className='stm-width-16 stm-height-16' />
                                                                                                                                                </Col>
                                                                                                                                            </Row>
                                                                                                                                        </Col>
                                                                                                                                    </Row>
                                                                                                                                </List.Item>
                                                                                                                            </Picker>
                                                                                                                        </Col>
                                                                                                                        :
                                                                                                                        null
                                                                                                                }
                                                                                                            </>
                                                                                                            <Col span={24} className=''>
                                                                                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                                                                    <DatePicker
                                                                                                                        value={bookingDate}
                                                                                                                        onChange={date => this.bookingDateOnChange({ date })}
                                                                                                                        format='MMMM dd, yyyy'
                                                                                                                        InputProps={{
                                                                                                                            endAdornment: (
                                                                                                                                <InputAdornment position="end">
                                                                                                                                    <Event />
                                                                                                                                </InputAdornment>
                                                                                                                            ),
                                                                                                                        }}
                                                                                                                        minDate={new Date()}
                                                                                                                        maxDate={maxDate}
                                                                                                                        okText={webSettting.okText}
                                                                                                                        dismissText={webSettting.cancelText}
                                                                                                                        className='stm-calendar' />
                                                                                                                </MuiPickersUtilsProvider>
                                                                                                            </Col>
                                                                                                        </Row>


                                                                                                        <div
                                                                                                            onTouchStart={(e) => this._onTouchStart(e, this)}
                                                                                                            onTouchMove={(e) => this._onTouchMove(e, this)}
                                                                                                            onTouchEnd={(e) => this._onTouchEnd(e, this, tab.id)}>
                                                                                                            <BookingTabPage items={itemFilters} />
                                                                                                        </div>
                                                                                                    </>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </TabPane>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </Tabs>
                                                                    </Col>
                                                                </Row>
                                                        }
                                                    </>

                                                </Content>
                                            </>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(BookingMainPage)
